import axiosInstance from "app/axiosInstance";
import { customerPortal } from "@vilocnv/allsetra-core";

type Icon = customerPortal.icons.Icon;

export const getIcons = async (): Promise<Icon[]> => {
  try {
    const response = await axiosInstance.get<Icon[]>(`/icons`);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
